import instance from "..";

export const fetchAgreementPreview = async (
  accountId: string,
  agreement: string,
): Promise<Blob> => {
  const res = await instance.get(
    `/accounts/${accountId}/agreements/${agreement}/preview`,
    { responseType: "blob" },
  );
  return res.data;
};

export const postAgreement = async ({
  ownerId, // Indicates which owner will be updated with the agreement acceptance
  agreement,
  accountId, // Required when agreement is per-account
  signerPartyId, // Required when ownerId is for a legal entity - consider using postAgreementForLegalEntityAndSigner if the signer needs an agreement as well
  revision,
  agreementText,
}: {
  ownerId: string;
  agreement: string;
  accountId?: string;
  signerPartyId?: string;
  revision?: string;
  agreementText?: string;
}) => {
  const res = await instance.post(`/owner/${ownerId}/agreements`, {
    agreement_type: agreement,
    account_id: accountId,
    revision,
    signer_party_id: signerPartyId,
    agreement_text: agreementText,
  });
  return res.data;
};
